import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { Box as PRCBox } from '@primer/react';
import { Link, Button, Heading, InlineLink, Text } from '@primer/react-brand';
import { version } from '../../../packages/react/package.json';
import { LinkExternalIcon } from '@primer/octicons-react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PRCBox sx={{
      p: 5,
      mt: 5
    }} mdxType="PRCBox">
  <Heading as="h4" mdxType="Heading">Primer Brand</Heading>
  <Text as="p" mdxType="Text">Read the installation instructions to get started.</Text>
  <PRCBox sx={{
        mt: 4,
        flexDirection: 'row',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        columnGap: '0.75rem'
      }} mdxType="PRCBox">
    <p>
      <Button as="a" variant="primary" href="/brand/getting-started" mdxType="Button">
        Installation instructions
      </Button>
    </p>
    <p>
      <Button as="a" variant="secondary" href="/brand/storybook" target="_blank" mdxType="Button">
        Storybook
      </Button>
    </p>
    <p>
      <Button as="a" variant="secondary" href="https://github.com/primer/brand" target="_blank" mdxType="Button">
        Contribute
      </Button>
    </p>
  </PRCBox>
  <PRCBox sx={{
        mt: 5
      }} mdxType="PRCBox">
    <Text as="p" mdxType="Text">
      <Text weight="semibold" mdxType="Text">Latest release:</Text>{' '}
      <PRCBox as="span" sx={{
            mr: 3,
            display: 'inline-block'
          }} mdxType="PRCBox">
        <InlineCode sx={{
              mr: 2
            }} mdxType="InlineCode">
          <a href="https://github.com/primer/brand/releases">v{version}</a>
        </InlineCode>
        .
      </PRCBox>
      <Text size="100" mdxType="Text">
        <a href="https://github.com/primer/brand/blob/main/packages/react/CHANGELOG.md">
          Read the change log <LinkExternalIcon mdxType="LinkExternalIcon" />
        </a>
      </Text>
    </Text>
  </PRCBox>
    </PRCBox>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      